<template>
    <div>
        <van-popup class="noticeDetailPop" v-model="showPop" closeable close-icon="close">
            <div class="noticeDetailPop-content">
                <div class="noticeDetailPop-title">{{ $t('misc.platform_notice') }}</div>
                <div class="noticeDetailPop-name">{{info.name}}</div>
                <div class="noticeDetailPop-content">{{info.text||info.content}}</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            info: {},
            showPop: false
        };
    },
    methods: {
        show(info){
            this.info=info
            this.showPop=true
        },
    },
    created() {
        this.getxuanfeidata();
    },
};
</script>

<style scoped lang="less">
.noticeDetailPop{
    /deep/.van-popup__close-icon{
        font-size: 32px !important;
        color: #fff !important;
    }
}
.noticeDetailPop-content{
    width: 600px;
    .noticeDetailPop-title{
        height: 80px;
        line-height: 80px;
        background-color: #ff4d67;
        text-align: center;
        font-size: 32px;
        color: #fff;
    }
    .noticeDetailPop-name{
        /* 标题行改为自适应高度：站内信的 name 是整句长文本，固定 80px 会与正文重叠 / auto height so long message titles no longer overlap the body */
        min-height: 80px;
        line-height: 1.4;
        position: relative;
        border-bottom: 0.5px solid #666;
        padding: 16px 24px;
        font-size: 32px;
        color: #333;
        margin-left: 24px;
        width: calc(100% - 48px);
        box-sizing: border-box;
        word-break: break-all;
    }
    .noticeDetailPop-content{
        max-height: 580px;
        min-height: 240px;
        overflow-y: auto;
        font-size: 28px;
        color: #000;
        padding: 24px;
    }
}
</style>
